<template>
    <ThePage>
        <h4 class="text-danger">Доступ к личному кабинету ограничен</h4>

        <div>Для решения любых вопросов, пожалуйста, свяжитесь с нашей <a href="https://telemetron.ru/contacts/feedback">службой поддержки</a>.</div>
        <div>E-mail: <a href="mailto:support@telemetron.ru">support@telemetron.ru</a></div>

        <router-link :to="{ name: 'recharge' }" class="btn btn-lg-192 btn-primary my-3">Пополнить счет</router-link>
    </ThePage>
</template>

<script>
import ThePage from '@/components/ThePage'

export default {
    components: {
        ThePage
    }
}
</script>
